import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {Employee, EmployeeSearch, ReduxPagination} from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[Employee] loadAll Success",
  props<{ employees: Employee[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Employee] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[Employee] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const searchSuccess = createActionWithCorrelation(
   "[Employee] search Success",
   props<{ searchResult: EmployeeSearch }>()
);
export const searchError = createActionWithCorrelation(
   "[Employee] search Error",
   props<{error: any}>()
);
export const search = createActionWithCorrelation(
   "[Employee] search",
   props<{
      query?: string;
      useState: boolean;
      useDefaultPage: boolean;
   }>(),
   searchSuccess.type,
   searchError.type
);

export const updatePerPageSuccess = createActionWithCorrelation(
   '[Employee] update perPage success',
   props<{ pagination: ReduxPagination }>()
);
export const updatePerPageError = createActionWithCorrelation(
   '[Employee] update perPage error',
   props<{ error: any }>()
);
export const updatePerPage = createActionWithCorrelation(
   '[Employee] update perPage',
   props<{ perPage: number }>(),
   updatePerPageSuccess.type,
   updatePerPageError.type
);

export const updatePageSuccess = createActionWithCorrelation(
   '[Employee] update Page success',
   props<{ pagination: ReduxPagination }>()
);
export const updatePageError = createActionWithCorrelation(
   '[Employee] update Page error',
   props<{ error: any }>()
);
export const updatePage = createActionWithCorrelation(
   '[Employee] update Page',
   props<{ page: number }>(),
   updatePageSuccess.type,
   updatePageError.type
);

export const updateQuerySuccess = createActionWithCorrelation(
    "[Employee] update query success",
    props<{ query: string }>()
);
export const updateQueryError = createActionWithCorrelation(
    "[Employee] update query error",
    props<{ error: any }>()
);
export const updateQuery = createActionWithCorrelation(
    "[Employee] update query",
    props<{ query: string}>(),
    updateQuerySuccess.type,
    updateQueryError.type
);
